import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchAssetsRequest,
  fetchAssetsSuccess,
  fetchAssetsFailure,
} from "../slices/assets.slice";
// import your asset fetching API here
function* fetchAssetsSaga(): Generator<any, void, any> {
  try {
    // Replace with real API call
    const assets = yield call(() => Promise.resolve([]));
    yield put(fetchAssetsSuccess(assets));
  } catch (err: any) {
    yield put(fetchAssetsFailure(err.message || "Failed to fetch assets"));
  }
}

export default function* assetsRootSaga() {
  yield takeLatest(fetchAssetsRequest.type, fetchAssetsSaga);
}
